require('../modules/es6.function.bind');
require('../modules/es6.function.name');
require('../modules/es6.function.has-instance');
module.exports = require('../modules/_core').Function;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/function.js
// module id = 341
// module chunks = 7 10